
define('template!pimProductDetailImageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(src !== '') { ;
__p += '\n    <img src="' +
((__t = ( src )) == null ? '' : __t) +
'">\n';
 } ;


}
return __p
};});

